import { Analytics } from 'aws-amplify';

let analyticsTimeout = null;

export const sendAnalytics = async (payload) => {
  if (analyticsTimeout == null) {
    analyticsTimeout = setTimeout(() => {
      analyticsTimeout = null;
      try {
        Analytics.record(payload);
      } catch (e) {
        console.error('Error sending analytics', e);
      }
    }, 3000);
  }
};
